import React, { Component } from 'react'
import { Checkbox, DatePicker, Form, Input, InputNumber, message, Popconfirm } from 'antd'
import moment from 'moment/moment'
import { dateVal, strVal } from '../../../modules/Utils'
import CustomSelect from '../../../elements/Select/CustomSelect'
import withSpinning from '../../../elements/HOC/withSpinning'
import { compose } from 'recompose'
import { get, isEmpty } from 'lodash'
import withUrlFetch from '../../../elements/Select/withUrlFetch'
import withSort from '../../../elements/HOC/withSort'
import withSelectFetch from '../../../elements/Select/withSelectFetch'
import withLoadingSection from '../../../elements/HOC/withLoadingSection'
import withData from '../../../elements/Select/withData'
import Leaves from '../../../api/Leaves'
import Status from '../../../elements/Status'

const { RangePicker } = DatePicker
const { TextArea } = Input

const EmployeeSelect = compose(
  withUrlFetch({
    name: 'employees',
    url: 'employees/?status=Active',
    cache: true,
  }),
  withSpinning
)(CustomSelect)

const LeaveTypeSelect = compose(
  withSelectFetch({ dropdown: 'employee', name: 'leaves' }),
  withSpinning,
  withSort
)(CustomSelect)

const MedicalLeaveTypeSelect = compose(
  withSelectFetch({ dropdown: 'employee', name: 'medicalLeaveType' }),
  withSpinning,
  withSort
)(CustomSelect)

const HalfType = compose(
  withData({
    data: [
      { key: 'am', value: 'AM' },
      { key: 'pm', value: 'PM' },
    ],
  })
)(CustomSelect)

class LeavesForm extends Component {
  api = new Leaves()
  state = {
    holidays: [],
  }

  async componentDidMount() {
    const holidays = await this.api.holidays()
    this.setState({
      holidays: holidays.MY.map((h) => moment(h.date)),
    })
  }

  calc = async (date) => {
    const employee = this.props.form.getFieldValue('owner._id')
    let start = date[0]
    let end = date[1]
    try {
      this.setState({
        fetchingTotal: true,
      })
      const leaveCode = this.props.form.getFieldValue('leave.code')
      const total = await this.api.getTotal({ start, end, leaveCode, employee })
      this.setState({
        fetchingTotal: false,
      })
      this.props.form.setFieldsValue({
        total,
        half: false,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.props.form.setFieldsValue({
        total: 0,
        half: false,
      })
      this.setState({
        fetchingTotal: false,
      })
    }
  }

  onChangeHalf = (e) => {
    if (isEmpty(this.props.form.getFieldValue('dateRange'))) return
    if (e.target.checked === true) {
      this.props.form.setFieldsValue({
        total: 0.5,
        dateRange: [
          this.props.form.getFieldValue('dateRange')[0],
          this.props.form.getFieldValue('dateRange')[0],
        ],
      })
    } else {
      const duration = moment.duration(
        this.props.form
          .getFieldValue('dateRange')[1]
          .diff(this.props.form.getFieldValue('dateRange')[0])
      )
      const days = duration.asDays() + 1
      this.props.form.setFieldsValue({
        total: days,
      })
    }
  }
  onChangeDate = async (date) => {
    if (!isEmpty(date)) {
      await this.calc(date)
    } else {
      this.props.form.setFieldsValue({
        total: 0,
        half: false,
      })
    }
  }
  disabledDate = (current) => {
    const leaveCode = this.props.form.getFieldValue('leave.code')
    const holidays = this.state.holidays.find((d) => d.isSame(current.format('YYYY-MM-DD')))
    const sunday = current.day() === 0
    const saturday = current.day() === 6
    const sundayIsAllowedInLieu = false

    const allowedSickDays = saturday || holidays || sunday
    const allowedInLieuDays = sundayIsAllowedInLieu ? !allowedSickDays || sunday : !allowedSickDays

    return (
      (current && leaveCode !== 'LL' && allowedSickDays) ||
      (leaveCode === 'LL' && allowedInLieuDays)
    )
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const {
      leave,
      type,
      option,
      onChangeEmployee,
      onChangeLeaveCode,
      handleOps,
      actions,
    } = this.props
    const { fetchingTotal } = this.state
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18, offset: 1 },
      },
    }

    const Operations = ({ contract, ...rest }) => {
      const ops = actions
        .filter((a) => option !== 'personal' || a.key === 'cancel')
        .map((a) => (
          <span>
            <Popconfirm
              placement="left"
              title={`Are you sure to ${a.value}?`}
              onConfirm={() => handleOps(a.key, leave)}
              okText="Yes"
              cancelText="No">
              <a>{a.value}</a>
            </Popconfirm>
          </span>
        ))
      return (
        <div {...rest}>
          {ops.length > 0
            ? ops.reduce((prev, curr) => [prev, <span className="ant-divider" />, curr])
            : []}
        </div>
      )
    }
    const status = get(leave, 'status')

    return (
      <Form layout={'horizontal'}>
        {type === 'edit' && (
          <Form.Item {...formItemLayout} label={'Status'}>
            <Status tooltip={false} value={status} />
            {type === 'edit' && (
              <Operations
                style={{ marginTop: '10px' }}
                contract={leave}
                status={strVal(leave, 'status')}
              />
            )}
          </Form.Item>
        )}
        {option !== 'personal' && (
          <Form.Item {...formItemLayout} label={'Employee'}>
            {getFieldDecorator('owner._id', {
              initialValue: type === 'edit' ? get(leave, 'owner.fn') : get(leave, 'owner._id'),
              rules: [{ required: true, message: 'Please Select a name!' }],
            })(
              <EmployeeSelect
                disabled={type === 'edit' || option === 'personal'}
                onChange={onChangeEmployee}
                placeholder={'Select an Employee'}
                keyAtr={'_id'}
                valueAtr={'name'}
              />
            )}
          </Form.Item>
        )}
        <Form.Item {...formItemLayout} label={'Type'}>
          {getFieldDecorator('leave.code', {
            initialValue: get(leave, 'leave.code'),
            rules: [{ required: true, message: 'Please Select a Type!' }],
          })(
            <LeaveTypeSelect
              placeholder={'Select Type'}
              keyAtr={'code'}
              valueAtr={'type'}
              onChange={onChangeLeaveCode}
            />
          )}
        </Form.Item>
        {this.props.form.getFieldValue('leave.code') === 'MC' && (
          <Form.Item {...formItemLayout} label={'Medical Type'}>
            {getFieldDecorator('leaveType', {
              initialValue: get(leave, 'leaveType'),
              rules: [{ required: true, message: 'Please Select a Type!' }],
            })(
              <MedicalLeaveTypeSelect
                placeholder={'Select Type'}
                keyAtr={'code'}
                valueAtr={'type'}
              />
            )}
          </Form.Item>
        )}

        <Form.Item validateStatus={fetchingTotal && 'validating'} {...formItemLayout} label="Date">
          {getFieldDecorator('dateRange', {
            initialValue: dateVal(leave, 'date.start') && [
              dateVal(leave, 'date.start'),
              dateVal(leave, 'date.end'),
            ],
            rules: [
              {
                required: true,
                message: 'Date range need to be selected ',
              },
            ],
          })(
            <RangePicker
              disabledDate={this.disabledDate}
              onChange={this.onChangeDate}
              style={{ width: '100%' }}
              format="ddd YYYY-MM-DD"
            />
          )}
          <Form.Item {...formItemLayout} label={'Total Days'}>
            {getFieldDecorator('total', {
              initialValue: get(leave, 'total'),
            })(<InputNumber disabled={true} placeholder="Total Days" />)}
          </Form.Item>
        </Form.Item>
        <Form.Item label="Half Day" {...formItemLayout}>
          {getFieldDecorator('half', {
            initialValue: leave.half,
            valuePropName: 'checked',
            rules: [{ required: true, message: "Half Day can't be empty " }],
          })(<Checkbox onChange={this.onChangeHalf} />)}
        </Form.Item>
        {this.props.form.getFieldValue('half') === true && (
          <Form.Item {...formItemLayout} label={'Period'}>
            {getFieldDecorator('period', {
              initialValue: get(leave, 'period'),
              rules: [{ required: true, message: 'Please Select a Period!' }],
            })(<HalfType placeholder={'Select Period'} />)}
          </Form.Item>
        )}
        <Form.Item label="Reason" {...formItemLayout}>
          {getFieldDecorator('reason', {
            initialValue: strVal(leave, 'reason'),
          })(<TextArea placeholder="Reason" rows={4} />)}
        </Form.Item>
      </Form>
    )
  }
}

LeavesForm.propTypes = {}
LeavesForm.defaultProps = { leave: {}, option: 'hr', actions: [], type: 'new' }

export default compose(Form.create(), withLoadingSection)(LeavesForm)
